export const GET_NDA_EMBEDDED_URL_ATTEMPT = 'GET_NDA_EMBEDDED_URL_ATTEMPT';
export const GET_NDA_EMBEDDED_URL_SUCCESS = 'GET_NDA_EMBEDDED_URL_SUCCESS';
export const GET_NDA_EMBEDDED_URL_FAILURE = 'GET_NDA_EMBEDDED_URL_FAILURE';

export const GET_ENVELOP_ATTEMPT = 'GET_ENVELOP_ATTEMPT';
export const GET_ENVELOP_SUCCESS = 'GET_ENVELOP_SUCCESS';
export const GET_ENVELOP_FAILURE = 'GET_ENVELOP_FAILURE';

export const CLEAR_STATE = 'CLEAR_STATE';
